export default class Solutions {

    fares: [
        {
            segments: [
                {
                    stops: [
                        {
                            departure: {
                                date: string,
                                time: string,
                                airport: string,
                                terminal: string,
                                timestamp: number,
                                desc: string,
                                parent_city_code: string
                            },
                            arrival: {
                                date: string,
                                time: string,
                                airport: string,
                                terminal: string,
                                timestamp: number,
                                desc: string,
                                parent_city_code: string
                            },
                            number: number,
                            equipment: string,
                            airline: string,
                            operated_by: string,
                            tech_stops: [
                                null
                            ],
                            duration: number,
                            cabin: string,
                            booking_class: string,
                            fare_type: string,
                            airport_change: boolean,
                            airline_name: string,
                            operated_by_name: string,
                            flight_time: number,
                            layover_time: number,
                            bags_recheck_required: boolean
                        }
                    ],
                    duration: number,
                    airline: string,
                    cabin: string,
                    departure: {
                        date: string,
                        time: string,
                        airport: string,
                        terminal: string,
                        idx: number,
                        timestamp: number,
                        desc: string,
                        flags: {
                            nearby: boolean,
                            taxi: boolean,
                            shuttle: boolean,
                            hub: boolean,
                            flex: boolean,
                            type: number
                        },
                        parent_city_code: string
                    },
                    arrival: {
                        date: string,
                        time: string,
                        airport: string,
                        terminal: string,
                        idx: number,
                        timestamp: number,
                        desc: string,
                        flags: {
                            nearby: boolean,
                            taxi: boolean,
                            shuttle: boolean,
                            hub: boolean,
                            flex: boolean,
                            type: number
                        },
                        parent_city_code: string
                    },
                    airline_name: string
                }
            ],
            cost: {
                total: number,
                luggage_fee: number,
                luggage_total: number,
                taxes: number,
                base: number,
                types: [
                    {
                        category: string,
                        total: number,
                        taxes: number,
                        base: number,
                        luggage_fee: number,
                        luggage_total: number
                    }
                ]
            },
            duration: number,
            stops: number,
            group_id: number,
            company: string,
            price: {
                types: [
                    {
                        category: string,
                        fee: number,
                        total: number,
                        taxes: number,
                        base: number,
                        cc: number
                    }
                ],
                fee: number,
                total: number,
                taxes: number,
                base: number,
                cc: number
            },
            price_luggage: {
                types: [
                    {
                        category: string,
                        fee: number,
                        total: number,
                        taxes: number,
                        base: number,
                        cc: number
                    }
                ],
                fee: number,
                total: number,
                taxes: number,
                base: number,
                cc: number
            },
            session_id: string,
            airquote_id: string,
            consolidator: string,
            departure: {
                date: string,
                time: string,
                airport: string,
                terminal: string,
                timestamp: number,
                desc: string,
                parent_city_code: string
            },
            arrival: {
                date: string,
                time: string,
                airport: string,
                terminal: string,
                timestamp: number,
                desc: string,
                parent_city_code: string
            },
            route_hack_type: number,
            chunk_id: number,
            fallback: boolean,
            fare_id: number,
            type: number
        }
    ];
    price: number;
    price_luggage: number;
    taxes: number;
    prices: {
        adt: number,
        chd: number,
        inf: number
    };
    prices_luggage: {
        adt: number,
        chd: number,
        inf: number
    };
    AirQuoteID: string;
    itinerary_id: number;
    filter: number;
    result_age: number;
    itinerary: [
        {
            id: number,
            code: string,
            name: string,
            city: string,
            state: string,
            country: string,
            long: number,
            lat: number,
            cc: string,
            class: string,
            airport: boolean,
            currency: string,
            departure_date: string,
            byland: boolean,
            parent_city_code: string
        }
    ];
    travelers: {
        A: number,
        C: number,
        I: number
    };
    filters: {
        round_trip: boolean,
        flexible_dates: boolean,
        include_nearby: boolean,
        airport_change: boolean,
        cabin: string,
        hub: boolean,
        cluster: boolean,
        alliance: [
            number
        ]
    };
    currency: string;
    include_alternative_packages_solutions: boolean;
    route: string;
    created_at: string;
    tab_prices: [
        {
            additionalPropnumber: number,
            additionalProp2: number,
            additionalProp3: number
        }
    ];
    solutions_info: {
        itinerary: [
            {
                id: number,
                code: string,
                name: string,
                city: string,
                state: string,
                country: string,
                long: number,
                lat: number,
                cc: string,
                class: string,
                airport: boolean,
                currency: string,
                departure_date: string,
                byland: boolean,
                parent_city_code: string
            }
        ],
        travelers: {
            A: number,
            C: number,
            I: number
        },
        filters: {
            round_trip: boolean,
            flexible_dates: boolean,
            include_nearby: boolean,
            airport_change: boolean,
            cabin: string,
            hub: boolean,
            cluster: boolean,
            alliance: [
                number
            ]
        },
        currency: string,
        include_alternative_packages_solutions: boolean,
        route: string,
        created_at: string,
        itinerary_id: number,
        solutions: [
            {
                result_id: number,
                filter_by: number,
                price: number,
                is_top: boolean
            }
        ],
        package_prices_stats: {
            lowest_packages: {
                result_id: number,
                cost: number
            },
            lowest_customize: {
                result_id: number,
                cost: number
            }
        },
        xchange: [
            {
                additionalPropnumber: string,
                additionalProp2: string,
                additionalProp3: string
            }
        ]
    };
    package_prices_stats: {
        lowest_packages: {
            result_id: number,
            cost: number
        },
        lowest_customize: {
            result_id: number,
            cost: number
        }
    };
    xchange: [
        {
            additionalPropnumber: string,
            additionalProp2: string,
            additionalProp3: string
        }
    ]
}
    
